{
  "de": {
    "classroomScreen": {
      "buttons": {
        "annotate": "Zeichnen",
        "cardActions": "Aktionen",
        "clearAllDrawings": "Alle Zeichnungen entfernen",
        "eraser": "Radierer",
        "pencil": "Stift",
        "marker": "Marker",
        "continue": "Weiter",
        "createQrCode": "QR-Code erzeugen",
        "customTime": "Anderer Timer",
        "delete": "Löschen",
        "deleteCard": "Karte löschen",
        "drawTicket": "Neues Los ziehen",
        "duplicate": "Duplizieren",
        "embed": "Einbetten",
        "fifteenMinutes": "15 Minuten",
        "fiveMinutes": "5 Minuten",
        "green": "Grünes Licht",
        "groupMode": "Gruppenarbeit",
        "groupShuffle": "Gruppen mischen",
        "insertTool": "Tool einbinden",
        "moveToPage": "Seite {page}",
        "partnerMode": "Partnerarbeit",
        "pause": "Pause",
        "plenumMode": "Plenum",
        "red": "Rotes Licht",
        "reset": "Zurücksetzen",
        "resetTickets": "Alle Lose zurück in den Topf",
        "rollDice": "Würfeln",
        "showVideo": "Video anzeigen",
        "silenceMode": "Einzelarbeit",
        "start": "Starten",
        "stop": "Stopp",
        "submitList": "Lose in den Topf geben",
        "tenMinutes": "10 Minuten",
        "uploadFile": "Datei hochladen",
        "viewInSpotlight": "Karte im Spotlight-Modus öffnen",
        "yellow": "Gelbes Licht"
      },
      "components": {
        "dice": "Würfel",
        "embed": "Einbetten",
        "file": "Datei",
        "group": "Gruppe",
        "image": "Bild",
        "internalTool": "Tool",
        "lottery": "Lostopf",
        "qrcode": "Link",
        "stoplights": "Ampel",
        "stopwatch": "Stoppuhr",
        "text": "Text",
        "timer": "Timer",
        "video": "Video",
        "watch": "Uhr",
        "workMode": "Sozialform"
      },
      "confirm": {
        "deleteCard": {
          "title": "Karte löschen?",
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Alle Inhalte der aktuellen Karte werden dauerhaft entfernt."
        },
        "deletePage": {
          "title": "Aktuelle Seite löschen?",
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Alle Inhalte der aktuellen Seite werden dauerhaft entfernt."
        },
        "clearCanvas": {
          "title": "Alle Zeichnungen entfernen?",
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Alle Zeichnungen auf der aktuellen Seite werden dauerhaft entfernt."
        }
      },
      "flash": {
        "pageAdded": "Neue Seite hinzugefügt",
        "pageDeleted": "Seite entfernt",
        "pageUpdated": "Seite aktualisiert",
        "cardUpdateFailed": "Änderung konnte nicht gespeichert werden",
        "cardDeleteFailed": "Karte konnte nicht gelöscht werden",
        "cardCreateFailed": "Karte konnte nicht erstellt werden",
        "pageCreateFailed": "Seite konnte nicht erstellt werden",
        "pageDeleteFailed": "Seite konnte nicht gelöscht werden",
        "pageUpdateFailed": "Seite konnte nicht gespeichert werden",
        "pageReorderFailed": "Reihenfolge konnte nicht gespeichert werden",
        "canvasSaveFailed": "Zeichnung konnte nicht gespeichert werden",
        "saving": "Wird gespeichert…"
      },
      "headings": {
        "classroomScreen": "Digitale Tafel",
        "group": "Gruppe",
        "minScreenWidth": "Bitte öffne die Digitale Tafel auf einem Tablet oder Laptop"
      },
      "hints": {
        "embedCard": "Nutze das Tools-Modul, um fobizz Tools Materialien einzubinden. So wird beim Kopieren dieser Unterrichtseinheit automatisch eine eigene Version der integrierten Materialien angelegt.",
        "itemId": "Achte darauf, die Inhalte für andere freizugeben, damit sie richtig angezeigt werden können.",
        "itemType": "Wenn du dieses Tafelbild kopierst, wird für alle hier integrierten Inhalte automatisch eine neue Version angelegt. So kannst du eine bestehende Unterrichtseinheit ganz einfach für eine weitere Zielgruppe verwenden.",
        "maxLengthTitle": "Der Titel ist auf maximal 45 Zeichen beschränkt.",
        "minScreenWidth": "Um dir die Digitale Tafel ansehen zu können, benötigst du eine Auflösung von mindestens <strong>768&nbsp;Pixel</strong> Breite.",
        "noTicketsLeft": "Der Topf ist leer!"
      },
      "labels": {
        "diceCount": "Anzahl Würfel",
        "embed": "URL oder Iframe-Snippet",
        "embedInternal": "Vorschau anzeigen",
        "groupCount": "Anzahl Gruppen",
        "groupMode": "Gruppenarbeit",
        "groupSize": "Gruppengröße",
        "itemId": "Titel",
        "itemType": "Tool",
        "minutes": "Minuten",
        "partnerMode": "Partnerarbeit",
        "plenumMode": "Plenum",
        "qrcodeInternal": "QR-Code einbetten",
        "seconds": "Sekunden",
        "shuffleCondition": "Bedingung für Gruppenmischung",
        "silenceMode": "Einzelarbeit",
        "start": "Start",
        "title": "Titel für deine Karte",
        "continue": "Fortsetzen",
        "pause": "Pause"
      },
      "placeholders": {
        "enterItems": "Einen Eintrag pro Zeile, zum Beispiel:\nMax\nMoritz",
        "enterText": "Text eingeben…",
        "enterUrl": "URL eingeben…",
        "enterUrlOrSnippet": "URL oder iFrame-Snippet eingeben…",
        "enterVideoUrl": "YouTube- oder Vimeo-URL eingeben…",
        "names": "Ein Name pro Zeile, zum Beispiel:\nMax\nMoritz",
        "title": "Titel...",
        "typeName": "Name eintippen"
      },
      "validations": {
        "itemLocked": "Dieser Inhalt ist so eingestellt, dass nur der/die Autor*in die Inhalte sehen darf. Bitte kontaktiere ihn/sie, um das zu ändern."
      },
      "tooltips": {
        "editMode": "Bearbeiten",
        "drawMode": "Zeichnen"
      },
      "viewModes": {
        "tool": "Werkzeugmodus",
        "canvas": "Zeichenmodus"
      }
    },
    "schoolClass": {
      "classroom": {
        "labels": {
          "activateControls": {
            "stop": "Stopp"
          }
        }
      }
    }
  }
}
